import React from "react";
import { MultiColumnTable } from "@wac-ui-dashboard/wac_component_library";
import useApplicationDetail from "./useApplicationDetail";
import OverviewShimmer from "../../../Global/Shimmers/OverviewShimmer";

const ApplicationDetail = () => {
  const { sections, isFetching } = useApplicationDetail();
  return (
    <div>
      {isFetching ? (
        <div className="pro-p-4 pro-w-100">
          <OverviewShimmer />
        </div>
      ) : (
        <div className="pro-py-5">
          {sections.map((section, index) => (
            <div key={index} className="pro-mb-4">
              <MultiColumnTable
                minWidth={`30%`}
                title={section.title}
                data={section.data}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ApplicationDetail;
